import Enums from "../enums/enums";
import { SocketConnect } from "../helper/notificationHelper";
import { GetAllTabs, GetTabIdFromSessionStorage, SetMasterTab } from "../helper/tabHelper";

let tabChannel = null;
export const SetTabChannel = () => {
  try {
    tabChannel = new BroadcastChannel("PeakAccountTab");

    tabChannel.onmessage = async (event) => {
      if (event.data) {
        switch (event.data.broadcastType) {
          case Enums.BroadcastTabChannelType.MasterTabClose:
            let tabs = await GetAllTabs();
            let tabId = GetTabIdFromSessionStorage();
            if (tabs && tabs.length > 0 && tabs[0].id == tabId) {
              SetMasterTab();
              SocketConnect();
            }
            break;
        }
      }
    };
  } catch {
    tabChannel = null;
    throw new Error("Your browser doesn't support BroadcastChannel");
  }
};

export const BroadcastTabChannelMasterTabClose = () => {
  if (tabChannel) {
    tabChannel.postMessage({
      broadcastType: Enums.BroadcastTabChannelType.MasterTabClose,
      request: null,
    });
  }
};

export const CheckBroadcastIsSupport = () => {
  return tabChannel !== null;
};
